<template>
	<transition name="h-scale">
		<div class="o-modal" v-if="modalOpen" v-bind:class="{'o-modal--open': modalOpen}">
			<div class="o-container--500">
				<component :is="modalInner" v-bind="modalProps"></component>
			</div>
			<div v-on:click="closeModal()" class="o-modal__close">
				<span class="o-modal__icon--close icon i-close"><svg width="18" height="18" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>close</title><path d="M18 1.812L10.812 9 18 16.188 16.188 18 9 10.812 1.812 18 0 16.188 7.188 9 0 1.812 1.812 0 9 7.188 16.188 0z" fill="#fff" stroke="none" stroke-width="1" fill-rule="evenodd"></path><image src="/images/png/close.png" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href=""></image></svg></span>
			</div>
		</div>
	</transition>
</template>

<script>
	/**
	* Modal Component
	* @version 0.1.0
	* @Author Josh Ainsworth
	**/
  export default {

		name: 'v-modal',
		computed: {
			modalOpen () {
				return this.$store.state.modalOpen
			},
			modalInner() {
				return this.$store.state.modalContent
			},
			modalProps() {
				return this.$store.state.modalProps
			}
		},
		mounted: function () {
			document.addEventListener("keydown", (e) => {
				if (e.keyCode == 27) {
					this.closeModal()
				}
			});
		},
		methods: {
			closeModal() {
				if (this.modalOpen) {
					this.$store.commit('closeModal')
				}
			}
		}
  }
</script>



// WEBPACK FOOTER //
// modal.vue?5faf5a0a